export default "__VITE_ASSET__C_8hdL8g__"